import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { faDollarSign, faEnvelope } from "@fortawesome/free-solid-svg-icons";

import Etapas from "../../../Components/CardsPages/Etapas";
import AtendimentoDetalhado from "../../../Components/CardsPages/Atendimento/AtendimentoDetalhado";

import { IAtendimentoDetalhadoAoCliente } from "../../../Interfaces/AtendimentoCliente/Atendimento/AtendimentoInterfaces";
import KPIAtendimentoCliente from "./KPIAtendimentoCliente";
import {
    AtendimentoPageProvider,
    useAtendimentoPage,
} from "../../../Context/AtendimentoPage";
import Acoes from "../../../Components/CardsPages/Atendimento/Acoes";
import { IParcelas } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import DadosFinanceiros from "../../../Components/CardsPages/DadosFinanceiros";
import ParcelasAbertasCard from "../../../Components/CardsPages/ParcelasAbertas";
import { useUserInfor } from "../../../Context/User";

import "../../../Assets/css/pages/placeholder.css";
import EnvelopesGerados from "../../Vendas/EnvelopesGerados";
import StatusEtapa from "../../../Components/CardsPages/StatusEtapa";

interface IRouteParams {
    IDCaso: string;
}
interface IAtendimentoClientePageProps {
    IDCaso: number;
}

export default function AtendimentoCliente() {
    const params = useParams<IRouteParams>();

    return (
        <AtendimentoPageProvider ID_CASO={Number.parseInt(params.IDCaso)}>
            <AtendimentoClientePage IDCaso={Number.parseInt(params.IDCaso)} />
        </AtendimentoPageProvider>
    );
}

function AtendimentoClientePage(props: IAtendimentoClientePageProps) {
    const [bloquearAcoes, setBloquearAcoes] = useState(false);
    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoDetalhadoAoCliente;

    const { UserInfor } = useUserInfor();

    const extraTabs = useMemo(() => {
        const extraTabs = [
            {
                key: "#envelopesGerados",
                name: "Documentos Assinados",
                icon: faEnvelope,
                Component: () => <EnvelopesGerados />,
            },
        ];
        if (Atendimento.ID_CHAVE_ERP_VENDA) {
            extraTabs.push(
                ...[
                    {
                        key: "#financeiro",
                        name: "Dados Financeiros",
                        icon: faDollarSign,
                        Component: () => (
                            <div className="card card-custom">
                                <DadosFinanceiros
                                    ID_CHAVE_ERP={
                                        Atendimento.ID_CHAVE_ERP_VENDA ?? ""
                                    }
                                />
                            </div>
                        ),
                    },
                    {
                        key: "#parcelasAbertas",
                        name: "Parcelas em Aberto",
                        icon: faDollarSign,
                        Component: () => (
                            <ParcelasAbertasCard
                                ID_CHAVE_ERP={Atendimento.ID_CHAVE_ERP_VENDA}
                            />
                        ),
                    },
                ]
            );
        }

        return extraTabs;
    }, [Atendimento.ID_CHAVE_ERP_VENDA]);

    const boletoReq = useMemo(() => {
        const chave = Atendimento.ID_CHAVE_ERP_VENDA?.split("_");
        if (chave)
            return {
                NR_EMPRESA: Number.parseInt(chave[0]),
                DS_OBRA: chave[1],
                NR_VENDA: Number.parseInt(chave[2]),
            } as IParcelas;
    }, [Atendimento]);

    return (
        <>
            {Atendimento ? (
                <>
                    <div className="col-12 mb-5">
                        <Etapas
                            ID_CATEGORIA={Atendimento.ID_CATEGORIA_ATENDIMENTO}
                            ID_ETAPA={
                                Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            }
                            finalizado={!!Atendimento.DT_FIM}
                        />
                    </div>
                    {
                        <AtendimentoDetalhado
                            dadosERP={boletoReq}
                            IDCaso={props.IDCaso}
                            Atendimento={Atendimento}
                            extraTabs={extraTabs}
                            KPICard={() => (
                                <KPIAtendimentoCliente
                                    Atendimento={Atendimento}
                                />
                            )}
                            adicionalComponent={
                                Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO &&
                                !AtendimentoPage.bloquearInteracoes &&
                                (Atendimento.ID_USUARIO_RESPONSAVEL ===
                                    UserInfor.ID_USUARIO ||
                                    UserInfor.FUNCOES.some(
                                        (f) =>
                                            f.NM_FUNCAO ===
                                            "ADM_PERMITE_ACOES_TELA_ATENDIMENTO"
                                    )) ? (
                                    <>
                                        <StatusEtapa
                                            idEtapaCategoriaAtendimentoTipoCaso={
                                                Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                            setBloquearAcoes={setBloquearAcoes}
                                            idCaso={props.IDCaso}
                                        />
                                        <Acoes
                                            bloquearAcoes={bloquearAcoes}
                                            ID_CASO={Atendimento.ID_CASO}
                                            ID_ETAPA={
                                                Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                        />
                                    </>
                                ) : undefined
                            }
                        />
                    }
                </>
            ) : (
                <div className="text-muted text-center">
                    Atendimento não encontrado
                </div>
            )}
        </>
    );
}
